import { Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const Title = () => {
  const dictionary = Dictionary[DICTIONARY.Equipment];

  return (
    <>
      <Typography variant='h2' tabIndex={0}>
        {dictionary.title}
      </Typography>
    </>
  );
};
